import { AssessmentInfo } from "@verity/api-client/types";
import { OptionRelatedInstituteSettings, ProctoringOptionProfileV2 } from "@verity/proctoring-option/types";
import { ExemptedStudent, VerityInstituteSettings } from "../../types/common";
import { useEffect } from "react";
import styles from "../editQuiz.module.css";
import ExemptionSection from "../edit-quiz-modals/exemptionModal";

type ModerateTheQuizProps = {
	quizInfo: Pick<AssessmentInfo, "courseId">;
	profiles: Array<ProctoringOptionProfileV2>;
	refreshProfiles: () => Promise<void | Map<number, ProctoringOptionProfileV2>>;
	hasInstituteProfilePermissions: boolean;
	optionRelatedInstituteSettings?: OptionRelatedInstituteSettings;
	verityInstituteSettings: VerityInstituteSettings;
	enforcedProfilesOnly: boolean;
	setUploadedExemptedStudentsMap: React.Dispatch<React.SetStateAction<Map<number, ExemptedStudent>>>;
	setUploadedProfilesMap: React.Dispatch<React.SetStateAction<Map<number, ProctoringOptionProfileV2>>>;
	exemptionInfo: {
		nonExemptRoster: Map<number, ExemptedStudent>;
		exemptRoster: Map<number, ExemptedStudent>;
	};
	setExemptionInfo: React.Dispatch<
		React.SetStateAction<{
			nonExemptRoster: Map<number, ExemptedStudent>;
			exemptRoster: Map<number, ExemptedStudent>;
		}>
	>;
	filteredProfilesMap: Map<number, ProctoringOptionProfileV2>;
	setStudentsLoaded?: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function ModerateTheQuiz({
	quizInfo,
	profiles,
	refreshProfiles,
	hasInstituteProfilePermissions,
	optionRelatedInstituteSettings,
	verityInstituteSettings,
	enforcedProfilesOnly,
	setUploadedExemptedStudentsMap,
	setUploadedProfilesMap,
	exemptionInfo,
	setExemptionInfo,
	filteredProfilesMap,
	setStudentsLoaded,
}: ModerateTheQuizProps) {
	useEffect(() => {
		setUploadedProfilesMap(
			new Map(
				profiles
					.filter(
						(profile) =>
							(!enforcedProfilesOnly || profile.instituteProfile?.enforced) &&
							((profile.proctoringOption.isExtension && verityInstituteSettings.allowExtensionPlatform) ||
								(profile.proctoringOption.isLockdown && verityInstituteSettings.allowLockdownPlatform) ||
								(profile.proctoringOption.isMobile && verityInstituteSettings.allowMobilePlatform)),
					)
					.map((x) => [x.id, x]),
			),
		);
	}, [profiles, verityInstituteSettings]);

	return (
		<div className={styles.exemptStudentContainer}>
			<ExemptionSection
				courseId={quizInfo.courseId}
				loading={false}
				profilesMap={filteredProfilesMap}
				refreshProfiles={refreshProfiles}
				hasInstituteProfilePermissions={hasInstituteProfilePermissions}
				optionRelatedInstituteSettings={optionRelatedInstituteSettings}
				verityInstituteSettings={verityInstituteSettings}
				enforcedProfilesOnly={enforcedProfilesOnly}
				setUploadedExemptedStudentsMap={setUploadedExemptedStudentsMap}
				exemptionInfo={exemptionInfo}
				setExemptionInfo={setExemptionInfo}
				setStudentsLoaded={setStudentsLoaded}
			/>
		</div>
	);
}
